import { StyleSheet } from '@react-pdf/renderer'
import { PDF_COLORS } from 'features/reporting/pdfGeneration/constants/colors'
import { PDF_LAYOUT } from 'features/reporting/pdfGeneration/constants/layout'
import { PDF_TYPOGRAPHY } from 'features/reporting/pdfGeneration/constants/typography'

export const ELIGIBILITY_PDF_COLORS: Record<string, string> = {
  eligible: '#52c41a',
  not_eligible: '#ff4d4f',
  unclear: '#faad14',
}

export const NiiPdfStyles = StyleSheet.create({
  sectionCard: {
    marginBottom: PDF_LAYOUT.SPACING.XLARGE,
    borderWidth: PDF_LAYOUT.BORDER_WIDTH.NORMAL,
    borderColor: PDF_COLORS.BORDER_MEDIUM,
    borderRadius: PDF_LAYOUT.BORDER_RADIUS.SMALL,
  },

  sectionCardTitle: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.MEDIUM,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_LIGHT,
    backgroundColor: PDF_COLORS.PRIMARY,
    padding: `${PDF_LAYOUT.SPACING.MEDIUM}px ${PDF_LAYOUT.SPACING.LARGE}px`,
    borderTopLeftRadius: PDF_LAYOUT.BORDER_RADIUS.SMALL,
    borderTopRightRadius: PDF_LAYOUT.BORDER_RADIUS.SMALL,
  },

  sectionCardBody: {
    padding: PDF_LAYOUT.SPACING.LARGE,
  },

  descriptionRow: {
    flexDirection: 'row',
    borderBottomWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderBottomColor: PDF_COLORS.BORDER_LIGHT,
    minHeight: 28,
  },

  descriptionLabel: {
    width: '25%',
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_SECONDARY,
    padding: `${PDF_LAYOUT.SPACING.MEDIUM}px ${PDF_LAYOUT.SPACING.LARGE}px`,
    backgroundColor: PDF_COLORS.BACKGROUND_LIGHT_GRAY,
    borderRightWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderRightColor: PDF_COLORS.BORDER_LIGHT,
  },

  descriptionValue: {
    width: '75%',
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    color: PDF_COLORS.TEXT_PRIMARY,
    padding: `${PDF_LAYOUT.SPACING.MEDIUM}px ${PDF_LAYOUT.SPACING.LARGE}px`,
    lineHeight: PDF_TYPOGRAPHY.LINE_HEIGHT.RELAXED,
  },

  preformattedText: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    color: PDF_COLORS.TEXT_PRIMARY,
    lineHeight: PDF_TYPOGRAPHY.LINE_HEIGHT.RELAXED,
  },

  eligibilityTag: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 4,
    alignSelf: 'flex-start',
  },

  eligibilityTagText: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_LIGHT,
  },

  recommendationItem: {
    flexDirection: 'row',
    marginBottom: PDF_LAYOUT.SPACING.XSMALL,
    paddingLeft: PDF_LAYOUT.SPACING.MEDIUM,
  },

  recommendationBullet: {
    width: 12,
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    color: PDF_COLORS.TEXT_SECONDARY,
  },

  recommendationText: {
    flex: 1,
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    color: PDF_COLORS.TEXT_PRIMARY,
    lineHeight: PDF_TYPOGRAPHY.LINE_HEIGHT.RELAXED,
  },

  zoneBlock: {
    marginBottom: PDF_LAYOUT.SPACING.LARGE,
    padding: PDF_LAYOUT.SPACING.LARGE,
    backgroundColor: PDF_COLORS.BACKGROUND_LIGHT_GRAY,
    borderRadius: PDF_LAYOUT.BORDER_RADIUS.SMALL,
    borderWidth: PDF_LAYOUT.BORDER_WIDTH.THIN,
    borderColor: PDF_COLORS.BORDER_LIGHT,
  },

  zoneHeading: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: PDF_LAYOUT.SPACING.MEDIUM,
  },

  zoneColorDot: {
    width: 10,
    height: 10,
    borderRadius: 3,
  },

  zoneTitle: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_PRIMARY,
  },

  zoneImageBlock: {
    marginBottom: PDF_LAYOUT.SPACING.LARGE,
  },

  zoneImageLabel: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.SMALL,
    fontWeight: 'bold',
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.TEXT_SECONDARY,
    marginBottom: PDF_LAYOUT.SPACING.SMALL,
  },

  zoneImage: {
    maxHeight: 400,
    objectFit: 'contain' as const,
  },
})
